import { CheckableList } from 'components/CheckableList/CheckableList'
import { ChipsContainer } from 'components/CheckBox/CheckBox.styled'
import { CheckChip } from 'components/CheckBox/CheckChip'
import { Container, ContainerHeader, ContainerContent } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { ISelectValue } from 'constants/globalTypes'
import { days } from 'pages/Employees/employeesData'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { Flex, Tabs, TabsContainer } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { BodyText, TitleText } from 'styling/Typography'
import { IShiftProgramState } from 'types/operationShiftPrograms.interface'

export const Recurrence = ({ setStep, setState, state }: { setStep: (step: number) => void, setState?: any, state: IShiftProgramState }) => {
    const [frequency, setFrequency] = useState<'everyShift' | 'daily' | 'weekly' | 'custom'>(state?.frequencyType ?? 'everyShift')
    const [selectedDays, setSelectedDays] = useState<number[]>(state?.daysOfWeek ?? [])
    const [selectedShifts, setSelectedShifts] = useState<ISelectValue[]>(state?.shifts ?? [])

    const handleShiftsChange = (shifts: ISelectValue[]) => {
        setSelectedShifts(shifts)
        setState?.((prev: IShiftProgramState) => ({ ...prev, shifts }))
    }

    const parseShifts = (data: { data: { id: number; name: string }[] }) =>
        data.data.map((shift) => ({ label: shift.name, value: shift.id }))

    const handleNext = () => {
        if (!state.shifts.length) {
            toast.warn('Shifts are required')
            return
        }
        setStep(4)

    }
    const handleBack = () => setStep(2)

    const handleSelectDay = (day: number) => {
        setSelectedDays(prev => {
            const daysOfWeek = prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]
            setState((old: IShiftProgramState) => ({ ...old, daysOfWeek }))
            return daysOfWeek
        })
    }

    const handleFrequencyChange = (value: 'everyShift' | 'daily' | 'weekly' | 'custom') => {
        setFrequency(value)
        setState((prev: IShiftProgramState) => ({ ...prev, frequencyType: value }))
    }

    const handleIntervalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState((prev: IShiftProgramState) => ({ ...prev, customIntervalDays: Number(e.target.value) }))
    }

    return <>
        <Flex width='100%' gap='1rem' >
            <Container>
                <ContainerHeader>
                    <TitleText>Frequency</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <TabsContainer style={{ marginBottom: '1rem' }}>
                        <Tabs onClick={() => handleFrequencyChange('everyShift')} active={frequency === 'everyShift'}>Every Shift</Tabs>
                        <Tabs onClick={() => handleFrequencyChange('daily')} active={frequency === 'daily'}>Daily</Tabs>
                        <Tabs onClick={() => handleFrequencyChange('weekly')} active={frequency === 'weekly'}>Weekly</Tabs>
                        <Tabs onClick={() => handleFrequencyChange('custom')} active={frequency === 'custom'}>Custom</Tabs>
                    </TabsContainer>
                    {frequency == 'weekly' ? <>
                        <BodyText style={{ marginBottom: '1rem' }} >Select Days</BodyText>
                        <ChipsContainer>
                            {days
                                .map(d => <CheckChip key={d.value} active={selectedDays.includes(d.value)} onClick={() => handleSelectDay(d.value)} text={d.label} />)}
                        </ChipsContainer>
                    </> : frequency === 'custom' ? <Input placeholder='4..' type='number' labelText='Custom interval (days)' name='customIntervalDays' value={state.customIntervalDays} onChange={handleIntervalChange} /> : <></>}

                </ContainerContent>

            </Container>
            <Container >
                <ContainerHeader>
                    <TitleText>Shifts</TitleText>
                </ContainerHeader>
                <ContainerContent>
                    <CheckableList
                        link='shifts'
                        parserFunction={parseShifts}
                        searchEnabled
                        searchPlaceholder='Search shifts...'
                        selected={selectedShifts}
                        onChange={handleShiftsChange}
                        selectedLabelText='Selected shifts'
                        selectedPlaceholder='No shifts selected'
                        listMaxHeight='16rem'
                    />
                </ContainerContent>
            </Container>
        </Flex>
        <Flex gap='1rem' mt='32' justend>
            <Button variant='secondary' onClick={handleBack}>Back</Button>
            <Button variant='primary' onClick={handleNext} >Next</Button>
        </Flex>
    </>

}